import { isANumber } from '@gumtree/ui-library/src/utils/currency-service';

export const formatFieldValue = (value: number | string | undefined) => {
    if (!!value && isANumber(value)) {
        // Check if the number is negative
        const isNegative = Number(value) < 0;

        // Format the absolute value of the number
        const formattedValue = `£${Math.abs(Number(value)).toLocaleString()}`;

        // Prepend the negative sign for negative numbers
        return isNegative ? `-${formattedValue}` : formattedValue;
    } else {
        return '';
    }
};
